export default () => {
    const createMoveEventTypeMapItemBM = (fromEventTypeId: number, toEventTypeIdList: number[]): any => {
        return {
            fromEventTypeId: fromEventTypeId,
            toEventTypeIdList: toEventTypeIdList,
        };
    };

    return {
        createMoveEventTypeMapItemBM,
    };
};
